import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useSelector } from "react-redux";
import { APPLICABLE_INDUSTRY_IDS } from "../actionIds";

const ReviewAndRun = () => {
  const {
    brandDataInModal,
    startDate,
    endDate,
    selectedAction,
    selectedBrandConfigs,
    selectedProcessSettingMode,
    selectedFlowDestinationTableId,
    brandIndustryData,
  } = useSelector((state: any) => state.brandConfigurationReport);

  // Extracting brand names from the brandDataInModal
  const selectedBrandsForEndToEndSync = Array.isArray(brandDataInModal)
    ? brandDataInModal
        .map((item: { brandName: string }) => item.brandName)
        .join(", ")
    : "";

  const flowBrandNames = Array.isArray(selectedFlowDestinationTableId)
    ? Array.from(
        new Set(
          selectedFlowDestinationTableId.map(
            (item: { brandName: string }) => item.brandName,
          ),
        ),
      ).join(", ")
    : "";
  const selectedBrandsForFetcher = Array.isArray(selectedBrandConfigs)
    ? selectedBrandConfigs
        .map((item: { brandName: string }) => item.brandName)
        .join(", ")
    : "";
  const actionLabel =
    selectedAction === "End_to_end_sync"
      ? "End to end"
      : selectedAction === "business_advisor"
        ? "Advisor"
        : selectedAction === "unifier_business_advisor"
          ? "Unifier + Advisor"
          : selectedAction;

  const getIndustryIdForBrand = (brandId: any) =>
    (brandIndustryData?.query_output || []).find(
      (item: any) => String(item.brand_id) === String(brandId),
    )?.industry_id;
  const isApplicableIndustry =
    Array.isArray(brandDataInModal) &&
    brandDataInModal.length > 0 &&
    brandDataInModal.every((b: any) =>
      APPLICABLE_INDUSTRY_IDS.includes(
        Number(getIndustryIdForBrand(b.brandId)),
      ),
    );
  const isIndustryShortcutFlow =
    isApplicableIndustry &&
    (selectedAction === "Unifier" ||
      selectedAction === "business_advisor" ||
      selectedAction === "unifier_business_advisor");
  const industryProcessNames =
    selectedAction === "Unifier"
      ? ["Daily Events User Performance"]
      : selectedAction === "business_advisor"
        ? ["Raw Daily Events User Performance"]
        : selectedAction === "unifier_business_advisor"
          ? [
              "Raw Daily Events User Performance",
              "Daily Events User Performance",
            ]
          : [];

  const formatDateForUI = (dateStr: string) => {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr; // fallback if invalid
    return date.toLocaleDateString("en-GB"); // dd/mm/yyyy format
  };

  return (
    <Stack mt={2} flexDirection={"column"} gap={2}>
      <Stack flexDirection={"row"} gap={2}>
        <Stack flexDirection={"row"} gap={2} mt={2}>
          <Typography fontWeight="500" fontSize={14}>
            Selected Brand:{" "}
            <Typography component="span" fontSize={14}>
              {selectedAction === "End_to_end_sync" || isIndustryShortcutFlow
                ? selectedBrandsForEndToEndSync
                : selectedProcessSettingMode === "By Report"
                  ? selectedBrandsForFetcher
                  : flowBrandNames}
            </Typography>
          </Typography>
        </Stack>
        <Stack flexDirection={"row"} gap={2} mt={2}>
          <Typography fontWeight="500" fontSize={14}>
            Start Date:{" "}
            <Typography component="span" fontSize={14}>
              {formatDateForUI(startDate)}
            </Typography>
          </Typography>
        </Stack>
        <Stack flexDirection={"row"} gap={2} mt={2}>
          <Typography fontWeight="500" fontSize={14}>
            End Date:{" "}
            <Typography component="span" fontSize={14}>
              {formatDateForUI(endDate)}
            </Typography>
          </Typography>
        </Stack>
      </Stack>
      {selectedAction === "End_to_end_sync" && (
        <>
          <Typography fontWeight="500" fontSize={14}>
            End to end process
          </Typography>
        </>
      )}
      {selectedAction === "Fetcher" &&
        selectedProcessSettingMode === "By Report" && (
          <>
            {selectedBrandConfigs?.map((brand: any) => (
              <Box key={brand.brandId}>
                <Typography fontWeight="500" fontSize={14}>
                  {selectedAction} Processes for {brand.brandName}:
                </Typography>
                <Typography component="div" fontSize={14} mt={0.5}>
                  {brand.selectedConfigs.length > 0 ? (
                    brand.selectedConfigs.map((cfg: any, idx: number) => (
                      <Typography key={cfg.tableId} component="span">
                        {cfg.configName} ({cfg.tableId})
                        {idx !== brand.selectedConfigs.length - 1 && ", "}
                      </Typography>
                    ))
                  ) : (
                    <Typography component="span" fontStyle="italic">
                      No configs selected
                    </Typography>
                  )}
                </Typography>
              </Box>
            ))}
          </>
        )}
      {isIndustryShortcutFlow && (
        <Box>
          <Typography fontWeight="500" fontSize={14}>
            {actionLabel} Processes:
          </Typography>
          <Typography component="div" fontSize={14} mt={0.5}>
            {industryProcessNames.join(", ")}
          </Typography>
        </Box>
      )}
      {selectedAction !== "End_to_end_sync" &&
        !isIndustryShortcutFlow &&
        selectedProcessSettingMode === "By Flow" && (
          <Box>
            <Typography fontWeight="500" fontSize={14}>
              {actionLabel} Processes:
            </Typography>
            <Typography component="div" fontSize={14} mt={0.5}>
              {selectedFlowDestinationTableId.length > 0 ? (
                selectedFlowDestinationTableId.map((cfg: any, idx: number) => (
                  <Typography
                    key={`${cfg.brandId}-${cfg.configName}`}
                    component="span"
                  >
                    {cfg.brandName}: {cfg.configName}
                    {idx !== selectedFlowDestinationTableId.length - 1 && ", "}
                  </Typography>
                ))
              ) : (
                <Typography component="span" fontStyle="italic">
                  No configs selected
                </Typography>
              )}
            </Typography>
          </Box>
        )}
    </Stack>
  );
};

export default ReviewAndRun;
